import { createBahnGraphConfig, createGraph, addElement, assignColorsToGraph, createTab, createDisplay, addDisplay, } from "./graph";
import { createGraphElement } from "./element";
import produce from "immer";
import { plotConfigError } from "../errors";
import { colorSchemesNames } from "@focus/focusUI";
export const getInitialConfig = (pltConfig, data, colorPalette = colorSchemesNames.SINEBOW) => {
    const config = createBahnGraphConfig();
    const colX = "date";
    let graph = createGraph("Plot", "Date", "", true);
    const file = getFileName(data);
    for (let key in pltConfig) {
        if (key !== "date") {
            const element = createGraphElement(pltConfig[key], colX, key, file);
            graph = addElement(graph, element, colorPalette);
        }
    }
    graph = assignColorsToGraph(graph, colorPalette);
    const tab = createTab([graph], graph.title);
    const display = createDisplay([tab], tab.title);
    const finalConfig = addDisplay(config, display);
    return finalConfig;
};
export const getFileName = (data) => {
    let fileName = null;
    for (let key in data) {
        if (key.indexOf("-") != -1) {
            fileName = key.substring(key.indexOf("-") + 1);
            break;
        }
    }
    return fileName;
};
export const filterItem = (pltVariables) => (filter, item) => {
    const filterLower = filter.toLowerCase();
    const filterInItem = item.toLowerCase().indexOf(filterLower) !== -1;
    const filterInLabel = pltVariables[item].toLowerCase().indexOf(filterLower) !== -1;
    return filterInItem || filterInLabel;
};
export const updateConfig = (config, newGraph, graphId, selectorFolderType) => {
    if (selectorFolderType === "defined") {
        return produce(config, (draft) => {
            draft.selectorFolderList[0].selectorList.forEach((display) => {
                display.tabs.forEach((tab) => {
                    tab.graphs.forEach((singleGraph, index) => {
                        if (singleGraph.id === graphId) {
                            tab.graphs[index] = newGraph;
                        }
                    });
                });
            });
        });
    }
    else {
        return produce(config, (draft) => {
            draft.customSelectorFolderList[0].selectorList.forEach((display) => {
                display.tabs.forEach((tab) => {
                    tab.graphs.forEach((singleGraph, index) => {
                        if (singleGraph.id === graphId) {
                            tab.graphs[index] = newGraph;
                        }
                    });
                });
            });
        });
    }
};
export const customizeConfig = (config, selectorList) => {
    return produce(config, (draft) => {
        if (selectorList.length > 0) {
            draft.customSelectorFolderList[0].selectorList = selectorList;
        }
    });
};
export const getConfigGraphs = (grafosConfig) => {
    try {
        return grafosConfig.selectorFolderList[0].selectorList.flatMap((displays) => displays.tabs.flatMap((tab) => tab.graphs));
    }
    catch (e) {
        console.error(e.message);
        return [];
    }
};
export const getGraph = (grafosConfig, id, plotsType) => {
    let graph;
    try {
        if (plotsType === "defined") {
            grafosConfig.selectorFolderList.forEach((selectorFolderList) => {
                selectorFolderList.selectorList.forEach((selectorList) => {
                    selectorList.tabs.forEach((tab) => tab.graphs.forEach((singleGraph) => {
                        if (singleGraph.id === id) {
                            graph = singleGraph;
                        }
                    }));
                });
            });
        }
        if (plotsType === "custom") {
            grafosConfig.customSelectorFolderList.forEach((selectorFolderList) => {
                selectorFolderList.selectorList.forEach((selectorList) => {
                    selectorList.tabs.forEach((tab) => tab.graphs.forEach((singleGraph) => {
                        if (singleGraph.id === id) {
                            graph = singleGraph;
                        }
                    }));
                });
            });
        }
    }
    catch (_a) {
        throw plotConfigError();
    }
    return graph;
};
//# sourceMappingURL=plotConfig.js.map